import BGImageCard from '@/sections/customers/components/BGImageCard';
import netflixBG from '../assets/netflix.jpg';
import tableauBG from '../assets/tableau.jpg';
import { getDataBySelector } from '../customerData';

type FeaturedStoryProps = {
  bullets: {
    stat: string;
    description: string;
  }[];
  background: React.JSX.Element;
};

const netflixData = getDataBySelector('netflix');
const tableauData = getDataBySelector('tableau');

export const featuredStories: FeaturedStoryProps[] = [
  {
    bullets: [
      {
        stat: '60%',
        description: 'Reduction in total serial test execution time',
      },
      {
        stat: '250,000 hours',
        description: 'Saved annually on CI and local builds',
      },
      {
        stat: '30,684 hours',
        description: 'Saved annually with Predictive Test Selection',
      },
    ],
    background: (
      <BGImageCard
        bgImage={netflixBG}
        icon={netflixData.icon}
        text={netflixData.text}
        type={netflixData.type}
        gradientColor="red"
        target={netflixData.target}
      />
    ),
  },
  {
    bullets: [
      {
        stat: '15 hours',
        description: 'Given back every 2-weeks for heaviest software builders',
      },
      {
        stat: '$100M',
        description: 'Developer Productivity problem addressed',
      },
      {
        stat: '3 months',
        description: 'Payback period for Develocity',
      },
    ],
    background: (
      <BGImageCard
        bgImage={tableauBG}
        icon={tableauData.icon}
        text={tableauData.text}
        type={tableauData.type}
        gradientColor="purple"
        target={tableauData.target}
      />
    ),
  },
];
